export default {
  eyebrow: 'Portal partnera',
  title: 'Płatności',
  description: 'Twoja metoda płatności dla miesięcznej faktury platformy oraz każda faktura z pełnym rozliczeniem.',
  toasts: {
    checkout_error: 'Nie udało się rozpocząć płatności — spróbuj ponownie.',
    action_error: 'Akcja nie powiodła się — spróbuj ponownie.',
    onboarding_error: 'Nie udało się rozpocząć weryfikacji — spróbuj ponownie.',
    payment_method_in_use:
      'Licencje Twoich restauracji są rozliczane na tę metodę płatności, więc nie można jej usunąć. Zastąp ją nową.',
  },
  payout_bank_account: {
    title: 'Konto bankowe do wypłat',
    description:
      'Wypłaty udziału w przychodach są realizowane w walucie {{currency}}. Stripe przewalutuje przelew po jego otrzymaniu.',
    toasts: {
      saved: 'Konto bankowe zapisane',
      save_failed: 'Nie udało się zapisać konta bankowego. Sprawdź dane.',
    },
  },
  payout_onboarding: {
    title: 'Skonfiguruj konto wypłat',
    description:
      'Twój udział w przychodach jest wypłacany co miesiąc na konto wypłat Stripe. Ukończ weryfikację raz — do tego czasu wypłaty są wstrzymane.',
    missing: {
      title: 'Nadal wymagane przed rozpoczęciem wypłat:',
      bank_account: 'Dodaj konto bankowe, na które ma być wypłacany Twój udział w przychodach.',
      business_details: 'Uzupełnij dane firmy, takie jak adres, NIP lub numer rejestracyjny.',
      people: 'Dodaj dane przedstawiciela firmy, właścicieli lub dyrektorów.',
      documents: 'Prześlij dokumenty weryfikacyjne wymagane przez Stripe.',
      terms: 'Zaakceptuj regulamin Stripe.',
      other: 'Podaj pozostałe dane wymagane przez Stripe.',
    },
    start: 'Rozpocznij weryfikację',
    continue: 'Kontynuuj weryfikację',
    ready:
      'Konto wypłat zweryfikowane — Twój udział w przychodach jest wypłacany automatycznie po każdym cyklu rozliczeniowym.',
  },
  payment_method: {
    title: 'Metoda płatności',
    empty: 'Brak zapisanej metody płatności — miesięczna faktura nie może być pobierana automatycznie.',
    add: 'Dodaj metodę płatności',
    replace: 'Zastąp',
    remove: 'Usuń',
    remove_confirm: {
      title: 'Usunąć tę metodę płatności?',
      description:
        'Karta/polecenie jest natychmiast odłączane od Stripe. Bez metody płatności faktury — w tym już wystawione — są pobierane przez hostowaną fakturę Stripe zamiast automatycznie.',
      confirm: 'Usuń',
    },
  },
  invoices: {
    title: 'Faktury',
  },
};
